import { OfferCardSectionT } from "../../../domain";
import { OfferDispatchDivision } from "../components/offer-dispatch-division";
import { OffersHistory } from "./offers-history";
import { OffersQueue } from "./offers-queue";
import { RateEntry } from "../components/modals/rate-entry";
import { useHasPermissions } from "../../../../../public/auth/infrastructure/store/auth-context";
import { useTranslation } from "react-i18next";
import {
  Button,
  Modal,
  useDisclosure,
} from "../../../../../shared/infrastructure/ui";
import { OfferSortBy, OffersSidebarFilters } from "../components";
import React, { Fragment } from "react";

type OffersProps = {
  tab: OfferCardSectionT;
};

export const Offers = ({ tab }: OffersProps): React.ReactElement => {
  const { isOpen, close, open } = useDisclosure();
  const [t] = useTranslation("global");
  const hasPermissions = useHasPermissions("manage:all-approvals");

  return (
    <React.Fragment>
      <section className="grid h-screen grid-rows-[auto_1fr] overflow-y-auto bg-[#F1EFEF]">
        <section className="px-auto grid grid-rows-[auto_auto] gap-[24px]  md:pb-[20px]">
          <section className="mx-auto flex justify-between md:w-[648px] lg:w-[906px] xl:w-[1086px] 2xl:w-[1450px]">
            <section className="hidden md:block" />
            <section className="ml-5 grid	grid-cols-2 grid-rows-2 items-center gap-[24px]  md:ml-0 md:grid-flow-col md:grid-cols-none md:grid-rows-none">
              {hasPermissions ? (
                <OfferDispatchDivision tab={tab} />
              ) : (
                <Fragment></Fragment>
              )}
              <OffersSidebarFilters tab={tab} />
              <span className="hidden h-[12px] w-[1px] border-l-[1px] border-solid border-[#9E9E9E] md:block" />
              <OfferSortBy tab={tab} />
              <Button
                className="ml-auto mr-5 w-[80px] md:ml-0 md:mr-0"
                onClick={open}
              >
                {t<string>("context.private.screens.offers.rate-entry")}
              </Button>
            </section>
          </section>
        </section>
        <section className="grid h-full max-h-[100%] grid-rows-[auto_1fr] gap-[28px] overflow-y-auto">
          {tab === "queue" && <OffersQueue />}
          {tab === "history" && <OffersHistory />}
        </section>
      </section>
      <Modal
        open={isOpen}
        onClose={close}
        content={<RateEntry onClose={close} />}
        classNames={{
          content: "overflow-y-auto overflow-x-hidden p-0",
          paper: "rounded-[5px] min-w-[362px]",
        }}
      />{" "}
      {/* This divs with background are for tailwind recognizing this classes and add them to the output file. We are using them for the statuses but dynamically, so tailwind is not able to recognize them when build the output file */}
      <div className="h-0 bg-[#4CAF50]" />
      <div className="h-0 bg-[#F44336]" />
      <div className="h-0 bg-[#FFBD2E]" />
    </React.Fragment>
  );
};
